"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const smoothScroll_1 = __importDefault(require("./smoothScroll"));
const globalOptions_1 = require("../internal/globalOptions");
const globalOptions = (0, globalOptions_1.getGlobalOptions)();
const scrolling = (endPosition, opts) => {
    const options = Object.assign(globalOptions, opts);
    const start = window.pageYOffset;
    const end = endPosition + options.offset;
    (0, smoothScroll_1.default)({ start, end, ...options }, (position) => {
        window.scroll(0, position);
    });
};
exports.default = scrolling;
